import { IOperationModeRepository } from '../../core/domain/IOperationModeRepository'
import { OperationMode } from '../../core/domain/operationMode'

export class GetOperationModesUseCase {
    private repository: IOperationModeRepository

    constructor(repository: IOperationModeRepository) {
        this.repository = repository
    }

    async execute(): Promise<OperationMode[]> {
        return await this.repository.getAll()
    }
}
